import Vue from 'vue'
import App from './App'
import router from './router'
// store状态管理
import store from './store/app'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.use(MintUI)

Vue.config.productionTip = false

// // rem 单位自适应的配置文件
// import RemConfig from 'libs/rem_config'

// 请求链接地址
import urls from 'libs/urls.js'
Vue.prototype.$urls = urls // 其他页面在使用URLS的时候直接  this.$urls就可以了

// ajax请求方法
import axios from 'libs/http.js'
Vue.prototype.$http = axios // 其他页面在使用URLS的时候直接  this.$https就可以了

// Set default values using the global configuration.
if (process.env.NODE_ENV === 'development') {
    require('libs/common/mocktest') // 开发环境下，引入mockjs调试数据模块
} else {
    // 生产环境下
}

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js